(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-reviews-slider')) {
    customElements.define(
      'bc-reviews-slider',
      class BcReviewsSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.bc-reviews__track');
          this.dots = Array.from(this.querySelectorAll('.bc-reviews__dot'));
          if (!this.track) return;

          this.update = this.update.bind(this);
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.goTo(index));
          });
          this.addEventListener('shopify:block:select', (event) => {
            this.track.scrollTo({ left: event.target.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          });

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.update);
            this.resizeObserver.observe(this.track);
          }
          this.update();
        }

        disconnectedCallback() {
          if (this.track) this.track.removeEventListener('scroll', this.update);
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        get maxScroll() {
          return this.track.scrollWidth - this.track.clientWidth;
        }

        update() {
          const max = this.maxScroll;
          const scrollable = max > 1;
          const last = this.dots.length - 1;
          const active = scrollable && last > 0 ? Math.round((this.track.scrollLeft / max) * last) : 0;

          this.dataset.scrollable = scrollable;
          this.dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === active);
            if (index === active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }

        goTo(index) {
          const last = this.dots.length - 1;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollTo({
            left: last > 0 ? (this.maxScroll * index) / last : 0,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
